import { removeArrayDuplicates } from "../../helpers/arrayFunctions";
import { Item } from "./Item"




export const ItemList = ({ carritoItems = [] }) => {


  // Quita los elementos duplicados del array, para simplificar la lista del carrito
  const uniqueObjetArray = removeArrayDuplicates( carritoItems, "codigo" );
  console.log(uniqueObjetArray);

  // const allItemsCarry = countAllItems( carritoItems, 'codigo' );
  // console.log(allItemsCarry);
  
  console.log(carritoItems.length);
  
  

  return (
    <>
    <ul className="list-group">
    {/* <li className="list-group-item d-flex justify-content-between">
        <span className="align-self-center">Cant.</span>
        <span className="align-self-center">DESCRIPCIÓN</span> {/* Centrar texto en el renglón */}
        {/* <span className="align-self-center">P/U.</span> */}
        {/* <button className="btn btn-danger">Borrar</button> */}
    {/* </li>  */}
    </ul>
    <div className="col-lg-8">

      <ul className="list-group mt-3">
          {
              uniqueObjetArray.map( items => (
                  <Item key={items.id} item={ items } />

              ))
          }
      </ul>
    </div>
    </>
  )
}
